// MARK://dhk8/ui-restaurant/format
// Formateo de moneda MXN (centavos a display string).
export function formatCents(cents) {
    return new Intl.NumberFormat('es-MX', {
        style: 'currency',
        currency: 'MXN',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(cents / 100);
}
//# sourceMappingURL=format.js.map